import { useEffect, useState } from "react";

import ActivityList from "../components/activity/ActivityList";
import { Activity } from "../entities/interfaces/actviity";
import ActivityService from "../services/activity.service";

const Activities = () => {
  const [activities, setActivities] = useState<Activity[]>([]);

  useEffect(() => {
    getActivities();
  }, []);

  const getActivities = async () => {
    const res = await ActivityService.list();
    if (!res?.success) return;
    setActivities(res.data);
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-5">
          <h1 className="text-xl font-bold">Activity</h1>
          <p>Manage your organisation activity</p>
        </div>
      </div>
      <ActivityList activities={activities} />
    </div>
  );
};

export default Activities;
